"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/SmallTelephone.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SmallTelephone = function SmallTelephone(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 19.9 18.69"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Small Telephone Icon"), _react2.default.createElement("path", {
    className: "phone",
    d: "M3.94,18.69a1.09,1.09,0,0,1-.43-0.09L2,17.93a1,1,0,0,1-.53-0.53L0.09,14.25A1,1,0,0,1,.16,13.3L1,11.9A34.47,34.47,0,0,1,12.75,1l1.5-.82a1.07,1.07,0,0,1,.9-0.06l3.37,1.3a1,1,0,0,1,.56.5l0.71,1.41a1,1,0,0,1-.38,1.33L14.89,7.42a1.07,1.07,0,0,1-1.15,0l-1.55-1a19.43,19.43,0,0,0-5.26,5.14l0.89,1.29a1,1,0,0,1,0,1.18l-3,4.22A1.06,1.06,0,0,1,3.94,18.69Zm-1.22-2,1.09,0.48,2.66-3.72L5.2,11.58l0.25-.4a20.28,20.28,0,0,1,6.41-6.23l0.37-.21,2.1,1.33,4-2.49-0.47-.92L14.79,1.48l-1.35.74A32.93,32.93,0,0,0,2.26,12.67L1.5,13.88Zm3.9-3,0,0Zm0-.47h0Zm7.87-7h0Zm4-2.26h0Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = SmallTelephone;